import { useEffect, useRef } from 'react';
import maplibregl from 'maplibre-gl';
import './CenterMarkControl.css';
import { createNewElement } from '../../lib/createElements';


export const useCenterMarkControl = (map: maplibregl.Map | null, isShow: boolean) => {

    const centerMarkRef = useRef<HTMLElement | null>(null);

    /* *****************
     * 中心マーク表示・非表示切り替え
     * *****************/ 
    useEffect(() => {
        if(!map) { return; }
        // 地図に中心マークを追加
        const mapContainer = map.getContainer();

        if(isShow) {
            centerMarkRef.current = createNewElement('div', { className: 'center', style: {display: 'block'} });
            mapContainer.appendChild(centerMarkRef.current);
        } else {
            if(!centerMarkRef.current || mapContainer.getElementsByClassName('center').length === 0) { return; }
            mapContainer.removeChild(centerMarkRef.current);
            centerMarkRef.current.style.display = 'none';
        }
    }, [map, isShow]);

};
